import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "base-card" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    ($props.image_url)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: $props.image_url,
          alt: $props.imageAlt,
          class: "card-image"
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}